import { DEFAULT_COUNTRY } from '@/constants/config';
import { CURRENCY } from '@/constants/currency';
import COUNTRY_LIST from '@/data/country.json';

export const WebsiteModule = {
    state: () => ({
        currentWebsite: null,
    }),
    mutations: {
        setWebsite(state, data) {
            state.currentWebsite = data;
        },
        resetWebsite(state) {
            state.currentWebsite = null;
        },
    },
    getters: {
        currentCurrencyId(state) {
            return state.currentWebsite?.defaultCurrency?.id || CURRENCY;
        },
        currentWebsiteId(state) {
            return state.currentWebsite?.id;
        },
        currentWebsiteTimezone(state) {
            return state.currentWebsite?.timezone;
        },
        currentCountryInfo(state) {
            const info = COUNTRY_LIST.find(
                (item) => item.ISOCountryCode === state.currentWebsite?.id
            );
            return info || DEFAULT_COUNTRY;
        },
    },
    namespaced: true,
};
